/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Settlement_CashInputs */

const vi_order_settlement_cash = /** @type {(inputs: Order_Settlement_CashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiền mặt`)
};

/**

* @param {Order_Settlement_CashInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_settlement_cash = /** @type {((inputs?: Order_Settlement_CashInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Settlement_CashInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_settlement_cash(inputs)
});